import { ClearAllDialog } from "@/components/fly/ClearAllDialog";
import { ImportStartList } from "@/components/fly/ImportStartList";

export const NewEditionTab = ({ onChange }) => (
  <section className="fly-card p-5 border-red-500/30" data-testid="danger-zone">
    <h3 className="font-display text-xl font-bold uppercase text-red-300">Nowa edycja zawodów</h3>
    <p className="text-xs text-slate-400 mt-1 mb-3">Usuń zawodników z tej edycji (lista startowa, oceny i rejestracja). Pozostaw tylko kategorie i ceny. Wgraj nową listę startową.</p>
    <div className="grid gap-4">
      <ClearAllDialog onDone={onChange} />
      <ImportStartList onDone={onChange} />
    </div>
  </section>
);
